export default function SellerBanner() {
  return (
    <section className="w-full py-8 md:py-12 px-4 md:px-6 lg:px-8">
      <div className="w-full relative overflow-hidden rounded-2xl md:rounded-3xl bg-background-100 border border-background-200/70">
        <div className="absolute inset-0 opacity-5">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20African%20marketplace%20business%20scene%20with%20packages%20and%20laptop%20on%20dark%20background%2C%20subtle%20red%20and%20gold%20accents%2C%20professional%20editorial%20photography%2C%20warm%20ambient%20lighting%20minimal%20aesthetic&width=1200&height=400&seq=seller-banner-01&orientation=landscape"
            alt="Seller banner background"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6 p-6 md:p-10 lg:p-12">
          <div className="text-center md:text-left">
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 border border-accent-300 mb-3">
              <i className="ri-store-2-line text-accent-700 text-sm" />
              <span className="text-xs font-semibold text-accent-700 uppercase tracking-wider">For Sellers</span>
            </div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-900 mb-2">
              Start Selling on KenStore
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-lg">
              Reach millions of customers across Kenya and East Africa. Set up your store in minutes with zero setup fees.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <a
              href="/become-seller"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors shadow-lg shadow-primary-500/25 whitespace-nowrap"
            >
              <i className="ri-store-line" />
              Open Your Store
            </a>
            <a
              href="/seller/learn"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-background-50 border border-background-200 text-foreground-700 font-semibold text-sm md:text-base hover:bg-background-200 transition-colors whitespace-nowrap"
            >
              <i className="ri-book-open-line" />
              Learn More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}